import { Box, Chip, Grid, Stack, Typography } from "@mui/material";
import { allColors } from "../../constants";
import GlobalButton from "../../components/globalButton";
import { images } from "../../assets";
import { useEffect, useState } from "react";

const WORK_DATA = [
    {
        id: 1,
        title: "Web App",
        image: images.developmentServiceWorkImg1,
    },
    {
        id: 2,
        title: "Mobile App",
        image: images.developmentServiceWorkImg2,
    },
    {
        id: 3,
        title: "UI/UX",
        image: images.developmentServiceWorkImg3,
    },
    {
        id: 4,
        title: "Logo Design",
        image: images.developmentServiceWorkImg4,
    },
    {
        id: 5,
        title: "SEO & Digital Marketing",
        image: images.developmentServiceWorkImg5,
    }
]

const OurWork = () => {

    const [selectedWork, setSelectedWork] = useState(WORK_DATA[0]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setSelectedWork((prevWork) => {
                const currentIndex = WORK_DATA.findIndex((work) => work.id === prevWork.id);
                const nextIndex = (currentIndex + 1) % WORK_DATA.length;
                return WORK_DATA[nextIndex];
            });
        }, 4500);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <Box component={"section"} mt={{ xs: 4, sm: 6, md: 8 }}
            px={{ xs: 2, sm: 6, md: 8 }}

            id="our-work">
            <Grid container spacing={2}
                alignItems="center"
            >
                <Grid item xs={12} md={5}>
                    <Typography
                        fontFamily="Raleway"
                        fontWeight="400"
                        color={allColors.jetBlack}
                        fontSize={{ xs: "25px", md: "35px" }}
                    >
                        Our Work
                    </Typography>
                    <Typography
                        variant="body1"
                        fontFamily="Raleway"
                        fontWeight="400"
                    >
                        A showcase of our recent work for our
                        industry-leading clients.
                    </Typography>
                    <Stack direction="row" flexWrap="wrap" my={2} gap={1}>
                        {WORK_DATA.map((work) => (
                            <Chip
                                key={work.id}
                                label={work.title}
                                color="primary"
                                variant="outlined"
                                sx={{
                                    color: selectedWork.id === work.id ? allColors.white : allColors.silverSand,
                                    backgroundColor: selectedWork.id === work.id ? allColors.blueBerry : allColors.white,
                                    borderColor: selectedWork.id === work.id ? allColors.blueBerry : allColors.silverSand,
                                    "&:hover": {
                                        backgroundColor: `${allColors.blueBerry} !important`,
                                        color: `${allColors.white} !important`,
                                        borderColor: `${allColors.blueBerry} !important`,
                                    }
                                }}
                                onClick={() => setSelectedWork(work)}
                            />
                        ))}
                    </Stack>

                    <GlobalButton
                        variant={"outlined"}
                        title="Lets Discuss"
                        handleClickBtn={() => {
                            document
                                .getElementById("development-service-contact-us")
                                ?.scrollIntoView({ behavior: "smooth", block: "start" });
                        }}

                        style={{
                            color: allColors.silverSand,
                            borderColor: allColors.silverSand,
                            borderRadius: "2px",
                            height: "50px",
                            width: "100%",

                        }}

                        hoverProperties={{
                            borderColor: allColors.silverSand,
                            backgroundColor: "transparent",
                            color: allColors.silverSand,
                        }}


                    />
                </Grid>

                <Grid item xs={12} md={7}>
                    <Box
                        component={"img"}
                        src={selectedWork.image}
                        alt="Our Work"
                        height={{ xs: "100%", md: "80%" }}
                        width={"100%"}
                        sx={{
                            transition: "opacity 0.45s ease-in-out, transform 0.45s ease-in-out",
                            transform: "translateZ(0)",
                        }}
                    />

                </Grid>
            </Grid>


        </Box>
    )
}

export default OurWork;